import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';

import MenuItem from './MenuItem';

const useStyles = makeStyles(() => ({
  container: {
    margin: '0',
    padding: '0',
    position: 'relative',
    listStyle: 'none'
  }
}));

const Menu = ({ menuItems, collapsedSideMenuHover }) => {
  const styles = useStyles();

  const pathname = useLocation().pathname;
  return (
    <ul className={styles.container}>
      {_.map(menuItems, (item, idx) => (
        <MenuItem
          key={`menuitem-${idx}`}
          item={item}
          active={pathname.startsWith(item.to.replace('#', ''))}
          collapsedSideMenuHover={collapsedSideMenuHover}
        />
      ))}
    </ul>
  );
};

export default Menu;
